"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _slicedToArray = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 *
 * @param attributes Event attributes to flatten.
 * @returns flattened event attributes.
 * Note: This function needs to be extended to support 'Array', 'object'
 * as value types within the event attributes if added later.
 */

var flattenEventAttributes = function flattenEventAttributes(attributes) {
  var flattenedAttributes = {};

  for (var _i = 0, _Object$entries = Object.entries(attributes); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (value === null || value === undefined || value === '') {
      continue;
    } else if (typeof value === 'number' || typeof value === 'string') {
      flattenedAttributes[key] = value;
    } else {
      throw new TypeError('Unhandled type received while flattening attributes.');
    }
  }

  return flattenedAttributes;
};

exports.default = flattenEventAttributes;